import { Injectable } from '@angular/core';

import { TextEncodingService } from '../../shared/services/text-encoding.service';
import { decryptData, encryptData } from '../../shared/utilities/encryption.utility';
import { EncryptionKeyService } from './encryption-key.service';
import { WebCryptoService } from './web-crypto.service';

@Injectable({
    providedIn: 'root'
})
export class EncryptionService {
    constructor(
        private readonly encodingService: TextEncodingService,
        private readonly encryptionKeyService: EncryptionKeyService,
        private readonly webCryptoService: WebCryptoService
    ) {
    }

    // TODO: Log telemetry for encryption exceptions.
    public async encryptData<T>(toEncrypt: T): Promise<ArrayBuffer> {
        const key = await this.encryptionKeyService.key;

        return encryptData<T>(
            toEncrypt,
            key,
            this.webCryptoService.crypto,
            toEncode => this.encodingService.encode(toEncode)
        );
    }

    // TODO: Log telemetry for decryption exceptions.
    public async decryptData<T>(toDecryptPlusIv: Uint8Array, reviver?: (key: string, value: any) => any): Promise<T> {
        const key = await this.encryptionKeyService.key;

        return decryptData<T>(
            toDecryptPlusIv,
            key,
            this.webCryptoService.crypto,
            toDecode => this.encodingService.decode(toDecode),
            reviver
        );
    }
}
